import { Ass_03, Exp_03 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const RAIVO_SALARY: Template = {
  id: "d026ca77-052c-4ec7-bb53-cb6d291a2cbf",
  name: "Raivo palk",
  variables: [
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Amount",
      value: "1056.30"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: "Raivo palk",
      items: [
        {
          title: "Palga välja maksmine",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Exp_03,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
